import { render } from "./logoView.vue?vue&type=template&id=592c6ad0"
import script from "./logoView.vue?vue&type=script&lang=js"
export * from "./logoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__